<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
:root {
  --el-color-primary: #c7000a;
  --el-color-primary-light-3: #e06a6f;
  --el-color-primary-light-5: #f0a5aa;
  --el-color-primary-light-7: #f8d3d5;
  --el-color-primary-light-9: #fdf1f2;
  --el-color-primary-dark-2: #8a0012;
  --el-color-success: #1fa63a;
  --el-color-warning: #ff9f0a;
  --el-color-danger: #d92d20;
  --el-color-info: #5f6368;
  --brand-text: #222222;
  --brand-muted: #5d5d5d;
  --brand-border: #e5e7eb;
  --brand-bg-alt: #f7f7f7;
}
body {
  color: var(--brand-text);
}
</style>
